import React from "react"

const Recommend = ({className}) => (
  <></>
)

export default Recommend
